export default __webpack_public_path__ + "static/media/homepage-banner.1a09001b.png";